var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProduzioneDistintaAvanzamento',{staticClass:"ma-5",on:{"go_back":_vm.goBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }